import styled from "styled-components";
import Image from "../Image/Image";

export const ContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 48%;
  flex: 1;
`;

export const LeftContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 223.68px;
  gap: 12px;

  @media (max-width: 768px) {
    min-width: unset;
  }
`;

export const SectionLabel = styled.span`
  color: var(--color-text-muted);
  font-family: var(--font-family-primary);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;

export const ArrowContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 5;
  transform: translate(-50%, -50%);
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(22, 32, 52, 0.9);
  border: 1px solid rgba(var(--color-brand-300-rgb), 0.15);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow:
    0 4px 14px rgba(0, 0, 0, 0.3),
    0 0 0 4px rgba(var(--color-brand-400-rgb), 0.05);

  @media (max-width: 768px) {
    width: 32px;
    height: 32px;
  }

  @media (max-width: 350px) {
    width: 28px;
    height: 28px;
  }
`;

export const UploadImageContainer = styled.div`
  position: relative;
  height: 280px;
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  border-radius: 20px;
  border: 1px solid rgba(var(--color-brand-400-rgb), 0.42);
  background:
    radial-gradient(
      120% 60% at 30% -10%,
      rgba(var(--color-brand-300-rgb), 0.32) 0%,
      rgba(var(--color-brand-400-rgb), 0.28) 55%,
      rgba(var(--color-brand-600-rgb), 0.32) 100%
    ),
    linear-gradient(
      180deg,
      rgba(var(--color-brand-500-rgb), 0.22) 0%,
      rgba(var(--color-brand-700-rgb), 0.36) 100%
    );

  box-shadow:
    0 12px 26px rgba(var(--color-brand-700-rgb), 0.28),
    inset 0 1px 0 rgba(255, 255, 255, 0.32),
    inset 0 -4px 12px rgba(var(--color-brand-800-rgb), 0.32);

  @media (max-width: 768px) {
    height: 240px;
  }
`;

export const UploadImageButton = styled.button`
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  min-height: 38px;

  border-radius: var(--radius-pill);
  border: 1px solid rgba(var(--glass-white-rgb), 0.72);
  background:
    radial-gradient(
      140% 100% at 20% 0%,
      rgba(255, 255, 255, 0.3) 0%,
      rgba(255, 255, 255, 0) 55%
    ),
    linear-gradient(
      180deg,
      var(--color-brand-400) 0%,
      var(--color-brand-600) 55%,
      var(--color-brand-700) 100%
    );
  box-shadow:
    0 10px 22px rgba(var(--color-brand-600-rgb), 0.32),
    inset 0 1px 0 rgba(255, 255, 255, 0.55),
    inset 0 -3px 6px rgba(var(--color-brand-700-rgb), 0.3);
  color: var(--glass-text-on-pill);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: -0.005em;
  cursor: pointer;
  outline: none;
  overflow: hidden;

  border: 1px solid var(--glass-edge-soft);
  background: radial-gradient(
    130% 100% at 30% 15%,
    rgba(var(--glass-white-rgb), 0.78) 0%,
    rgba(var(--glass-white-rgb), 0.5) 45%,
    rgba(var(--glass-pale-rgb), 0.38) 100%
  );

  box-shadow:
    0 6px 14px rgba(var(--color-brand-500-rgb), 0.14),
    inset 0 1px 0 rgba(255, 255, 255, 0.95),
    inset 0 -3px 8px rgba(var(--color-brand-200-rgb), 0.22);
  color: var(--color-brand-700);
  background-color: var(--glass-base-1);
  min-height: 32px;
  max-height: 32px;
  transition:
    transform 200ms var(--ease-snappy),
    border-color 200ms var(--ease-snappy);

  [data-theme="dark"] & {
    border-color: transparent;
    background-color: var(--color-surface-3);
    box-shadow:
      0 4px 10px rgba(0, 0, 0, 0.45),
      inset 0 -2px 6px rgba(var(--color-brand-700-rgb), 0.16);
    color: var(--color-text-strong);
  }

  &::before {
    content: "";
    position: absolute;
    top: 3px;
    left: 6px;
    width: 18px;
    height: 10px;
    border-radius: 50%;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.85) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    filter: blur(1px);
    pointer-events: none;
  }

  [data-theme="dark"] &::before {
    opacity: 0;
  }

  &:hover {
    transform: translateX(-50%) translateY(-1px);
  }

  @media (max-width: 768px) {
    width: 88%;
  }
`;

export const DeleteButton = styled.button`
  position: absolute;
  top: 10px;
  left: ${(props) =>
    props.$shift ? `calc(10px + ${props.$shift}px)` : "10px"};
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border-radius: 50%;
  border: 1px solid var(--glass-edge-soft);
  background: radial-gradient(
    130% 100% at 30% 15%,
    rgba(var(--glass-white-rgb), 0.82) 0%,
    rgba(var(--glass-white-rgb), 0.54) 45%,
    rgba(var(--glass-pale-rgb), 0.42) 100%
  );
  backdrop-filter: blur(18px) saturate(180%);
  -webkit-backdrop-filter: blur(18px) saturate(180%);
  box-shadow:
    0 6px 14px rgba(var(--color-brand-500-rgb), 0.16),
    inset 0 1px 0 rgba(255, 255, 255, 0.95),
    inset 0 -3px 8px rgba(var(--color-brand-200-rgb), 0.22);
  color: var(--color-brand-700);
  cursor: pointer;
  outline: none;
  transition:
    transform 200ms var(--ease-snappy),
    border-color 200ms var(--ease-snappy),
    box-shadow 200ms var(--ease-snappy);

  [data-theme="dark"] & {
    border-color: transparent;
    background: var(--color-surface-3);
    box-shadow:
      0 4px 10px rgba(0, 0, 0, 0.45),
      inset 0 -2px 6px rgba(var(--color-brand-700-rgb), 0.16);
  }

  [data-theme="dark"] & svg path {
    stroke: var(--color-text-strong);
  }

  svg {
    width: 18px;
    height: 18px;
    position: relative;
    z-index: 1;

    path {
      stroke: var(--color-brand-700);
    }
  }

  &:hover {
    transform: translateY(-1px) scale(1.04);
    border-color: rgba(var(--color-brand-400-rgb), 0.5);
  }
`;

export const CropButton = styled.button`
  position: absolute;
  top: 10px;
  right: ${(props) =>
    props.$shift ? `calc(10px + ${props.$shift}px)` : "10px"};
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border-radius: 50%;
  border: 1px solid var(--glass-edge-soft);
  background: radial-gradient(
    130% 100% at 30% 15%,
    rgba(var(--glass-white-rgb), 0.82) 0%,
    rgba(var(--glass-white-rgb), 0.54) 45%,
    rgba(var(--glass-pale-rgb), 0.42) 100%
  );
  backdrop-filter: blur(18px) saturate(180%);
  -webkit-backdrop-filter: blur(18px) saturate(180%);
  box-shadow:
    0 6px 14px rgba(var(--color-brand-500-rgb), 0.16),
    inset 0 1px 0 rgba(255, 255, 255, 0.95),
    inset 0 -3px 8px rgba(var(--color-brand-200-rgb), 0.22);
  cursor: pointer;
  outline: none;
  transition:
    transform 200ms var(--ease-snappy),
    border-color 200ms var(--ease-snappy),
    box-shadow 200ms var(--ease-snappy);

  [data-theme="dark"] & {
    border-color: transparent;
    background: var(--color-surface-3);
    box-shadow:
      0 4px 10px rgba(0, 0, 0, 0.45),
      inset 0 -2px 6px rgba(var(--color-brand-700-rgb), 0.16);
  }

  [data-theme="dark"] & svg path {
    stroke: var(--color-text-strong);
  }

  svg {
    width: 16px;
    height: 16px;
    position: relative;
    z-index: 1;

    path {
      stroke: var(--color-brand-700);
    }
  }

  &:hover {
    transform: translateY(-1px) scale(1.04);
    border-color: rgba(var(--color-brand-400-rgb), 0.5);
  }
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 4px 0;
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid rgba(var(--color-brand-300-rgb), 0.22);
  background:
    radial-gradient(
      120% 60% at 30% -10%,
      rgba(var(--glass-white-rgb), 0.6) 0%,
      rgba(var(--glass-pale-rgb), 0.46) 60%,
      rgba(var(--glass-pale-rgb), 0.4) 100%
    ),
    linear-gradient(
      180deg,
      rgba(var(--glass-white-rgb), 0.58) 0%,
      rgba(var(--glass-pale-rgb), 0.46) 100%
    );
  backdrop-filter: blur(12px) saturate(160%);
  -webkit-backdrop-filter: blur(12px) saturate(160%);
  box-shadow:
    0 4px 10px rgba(var(--color-brand-500-rgb), 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.85);

  [data-theme="dark"] & {
    border-color: transparent;
    box-shadow:
      0 4px 10px rgba(0, 0, 0, 0.45),
      inset 0 -2px 6px rgba(var(--color-brand-700-rgb), 0.14);
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const OptionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: transparent;
  cursor: pointer;
  transition: background 180ms var(--ease-snappy);

  &:hover {
    background: rgba(var(--color-brand-300-rgb), 0.16);
  }
`;

export const OptionText = styled.span`
  color: var(--color-text-strong);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 600;
  letter-spacing: -0.005em;
`;

export const ToggleTrack = styled.div`
  position: relative;
  width: 40px;
  height: 22px;
  border-radius: 11px;
  background: ${({ $active }) =>
    $active
      ? "linear-gradient(180deg, var(--color-brand-400) 0%, var(--color-brand-600) 100%)"
      : "rgba(var(--color-brand-300-rgb), 0.2)"};
  border: 1px solid
    ${({ $active }) =>
      $active
        ? "rgba(var(--glass-white-rgb), 0.7)"
        : "rgba(var(--color-brand-300-rgb), 0.3)"};
  box-shadow: ${({ $active }) =>
    $active
      ?
      `0 4px 10px rgba(var(--color-brand-600-rgb), 0.3),
         inset 0 1px 0 rgba(255, 255, 255, 0.55)`
      : `inset 0 1px 2px rgba(var(--color-brand-300-rgb), 0.18)`};
  cursor: pointer;
  transition: all 220ms var(--ease-snappy);
  flex-shrink: 0;

  [data-theme="dark"] & {
    background: ${({ $active }) =>
      $active
        ? "linear-gradient(180deg, var(--color-brand-400) 0%, var(--color-brand-600) 100%)"
        : "rgba(var(--color-brand-900-rgb), 0.6)"};
    border-color: ${({ $active }) =>
      $active ? "transparent" : "rgba(var(--color-brand-400-rgb), 0.32)"};
    box-shadow: ${({ $active }) =>
      $active
        ? "0 4px 10px rgba(0, 0, 0, 0.5)"
        : "inset 0 1px 2px rgba(0, 0, 0, 0.4)"};
  }
`;

export const ToggleThumb = styled.div`
  position: absolute;
  top: 2px;
  left: ${({ $active }) => ($active ? "20px" : "2px")};
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: ${({ $active }) =>
    $active ? "var(--glass-base-1)" : "var(--glass-base-1)"};
  box-shadow:
    0 2px 4px rgba(var(--color-brand-900-rgb), 0.28),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  transition: left 220ms var(--ease-snappy);

  [data-theme="dark"] & {
    background: ${({ $active }) =>
      $active ? "#ffffff" : "rgba(var(--color-brand-300-rgb), 0.7)"};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  }
`;

export const StyledImage = styled(Image)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: ${(props) =>
    props.$hideImageContainer
      ? "transparent"
      : "rgba(var(--color-brand-300-rgb), 0.1)"};
  max-width: 100%;

  img {
    border-radius: 20px;
    max-width: 100%;
    max-height: 100%;
  }
`;
